import { api } from "@/api";
import { defineStore } from "pinia";
import { ref } from "vue";

interface Settings {
    name: string;
    company: string;
    ppn: number;
}

export const useSettingsStore = defineStore("settings", () => {
    const data = ref<Settings>({
        name: "MyRingNet",
        company: "PT Ring Media Nusantara",
        ppn: 11,
    });

    async function synchronize() {
        const result = await api.settings.clientConfig().execute();
        if (result === undefined) throw new Error("Failed to synchronize settings data");

        data.value = {
            name: result.name,
            company: result.company,
            ppn: result.ppn,
        };
    }

    return { data, synchronize };
});
